import Analytics from './analytics';

export const analytics = new Analytics();
export * from './providers';
